module.exports = __webpack_public_path__ + "img/Brexit_1024X768-1-768x576.d4f2ba5a.png";